<template>
  <div class="info_content" @click="openRule">
    <div class="rule" @click="openRule"></div>
    <!-- <div class="my_gift" @click="openMyGift"></div> -->
  </div>

  <van-popup v-model:show="state.ruleShow">
    <div class="rule">
      <div
        class="rule_content"
        :style="
          `background-image: url(https://oss.zhekoushenqi.com/data/homegameActivity/icon_rule_bg.png?t=${props.nowDay})`
        "
      >
        <div class="rule_info">
          <!-- <p>
            1.活动时间 <br />
            {{ state.activeTime }}
          </p>
          <p>
            2.活动规则：
            <br />完成任务后点击抽奖，点击翻牌领取奖励。活动期间账号首次登录游戏，可获得1次抽奖机会；活动期间账号在游戏内充值满6元（折扣抵扣金额,优惠券不计入），可获得1次抽奖机会，最高可获得1次。
          </p>
          <p>
            3.其他说明：
          </p>
          <p>
            (1)活动期间获得的抽奖次数仅限同一用户消耗使用。同一实名、手机号、手机设备，符合以上任一条件，均视为同一用户。
          </p>
          <p>
            (2)优惠券奖励可在【个人中心】-【优惠券】查收。
            余额奖励可在【个人中心】-【赠送余额】查收。
          </p>
          <p>
            (3)如有疑问，请至APP内【我的-联系客服】进行咨询。
          </p>
          <br /> -->
          <pre>{{ props.guize }}</pre>
        </div>
      </div>
      <button type="primary" @click="closeRule" round size="large">
        关闭
      </button>
      <span>
        <van-checkbox
          v-model="state.noTips"
          shape="square"
          checked-color="#6f4edd"
          icon-size="15px"
          @change="tipsChange"
          >下次不再提示</van-checkbox
        >
      </span>
    </div>
  </van-popup>

  <van-popup v-model:show="state.awardShow" closeable>
    <div
      class="award_content"
      :style="
        `background-image: url(https://oss.zhekoushenqi.com/data/homegameActivity/icon_prize_bg.png?t=${props.nowDay})`
      "
    >
      <div class="award_list">
        <ul>
          <li v-for="(item, index) in state.myLog">
            <p>{{ item.lottery_log_cont }}</p>
            <p>{{ dateYMDHM(item.lottery_log_time) }}</p>
          </li>
        </ul>
      </div>
    </div>
  </van-popup>
</template>

<script setup>
import { onMounted, nextTick, reactive, ref, watch } from "vue";
import { dateYMDHM } from "@/utils/date";
import { Toast } from "vant";

const state = reactive({
  ruleShow: false,
  myLog: "",
  awardShow: false,
  noTips: false,
  activeTime: "",
  guize: "",
});

onMounted(() => {
  state.noTips = localStorage.getItem("isShowRules");
  if (localStorage.getItem("isShowRules") == "false") {
    state.ruleShow = true;
    state.noTips = false;
  } else {
    state.ruleShow = false;
  }
});

const props = defineProps({
  myLog: {
    type: Array,
    default: () => [],
  },
  nowDay: {
    type: String,
    default: "",
  },
  activeTime: {
    type: String,
    default: "",
  },
  guize: {
    type: String,
    default: "",
  },
});
watch(
  () => props.myLog,
  (newLog) => {
    state.myLog = [...newLog].reverse();
  }
);
watch(
  () => props.activeTime,
  (newVal) => {
    state.activeTime = newVal;
  }
);

const openRule = () => {
  state.ruleShow = true;
};

const closeRule = () => {
  state.ruleShow = false;
};
const tipsChange = () => {
  localStorage.setItem("isShowRules", state.noTips);
};

const openMyGift = () => {
  state.awardShow = true;
};
</script>

<style scoped>
.info_content {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  letter-spacing: 8px;
  font-weight: 800;
  writing-mode: tb-rl;
  width: 54px;
  height: 104px;
  background-image: url('../../../assets/saveCardActivity/guize.png');
  background-size: 100% 100%;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  margin-bottom: 240px;
}
.info_content div {
  margin-bottom: 20px;
  width: 100%;
  height: 138px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.info_content i {
  height: 1px;
  width: 25px;
  margin-bottom: 20px;
  background-color: #979797;
}
h5 {
  position: fixed;
  right: 0;
  opacity: 0;
}

:deep(.van-popup) {
  background-color: rgba(0, 0, 0, 0);
}
/* 活动规则 */
.rule {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.rule_content {
  width: 588px;
  height: 624px;
  background-size: 100% 100%;
  padding: 98px 0 0 25px;
}
.rule_content .rule_info {
  width: 488px;
  height: 446px;
  margin: 20px 0 0 25px;
  font-size: 24px;
  font-weight: 800;
  overflow: auto;
}
.rule_content .rule_info p:nth-of-type(2) {
  margin: 20px 0;
}
.rule button {
  border: none;
  border-radius: 198px;
  background-color: #823f3f;
  width: 302px;
  height: 98px;
  font-size: 32px;
  font-weight: 500;
  color: #fff;
}
.rule span {
  margin-top: 32px;
}
.rule span :deep(.van-checkbox__label) {
  color: #fff;
}

/* 我的奖励 */
.award_content {
  width: 588px;
  height: 624px;
  background-size: 100% 100%;
  padding: 98px 0 0 25px;
}
.award_content .award_list {
  width: 500px;
  height: 485px;
  overflow: auto;
  margin: 0 12px;
  padding-top: 40px;
}
.award_list li {
  width: 100%;
  height: 120px;
  margin-bottom: 20px;
  border-bottom: 2px solid #999;
  color: #fff;
  font-weight: 500;
  font-size: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.award_list li p:nth-of-type(1) {
  font-size: 36px;
}

table {
  width: 100%;
  height: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
  font-size: 24px;
  color: #fff;
  border: 2px solid #fff;
  text-align: center;
}
pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>
